import React, { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";

// Importing bootstrap components
import { Form, Button, Table } from "react-bootstrap";

// Importing common components
import WarningAlert from "common/Alert";

import { batch, useDispatch, useSelector } from "react-redux";

// Importing team slices
import { setTeams, setIsDefaultSet } from "state/slices/team/teamSlice";

import { useGetTeamsQuery } from "state/slices/team/teamApiSlice";

const TeamViewManagement = React.memo(
  ({
    isAllowedToReadEmployees = false,
    isAllowedToUpdate = false,
    isAllowedToDelete = false,
    handleCheckboxChange = () => {},
    handleEdit = () => {},
    deleteTeamManage = () => {},
    selectedRow = null,
  }) => {

    const location = useNavigate();

    const dispatch = useDispatch();

    const { data, refetch, isLoading } = useGetTeamsQuery();

    const teams = useSelector((state) => state.team.teams);
    const isDefaultSet = useSelector((state) => state.team.isDefaultSet);

    useEffect(() => {
      if (data) {
        batch(() => {
          dispatch(setTeams(data.teams));
          dispatch(setIsDefaultSet(data.isDefaultSet));
        });
      }
    }, [data]);

    useEffect(() => {
      refetch();
    }, [teams]);

    // On Edit
    const onEdit = (row) => {
      let { teamLeadId, ...teamData } = row;

      // Add key
      teamData.teamLeadId = teamLeadId?.id || "";

      handleEdit(teamData);
    };

    const viewTeamEmployees = (teamId) => {
      location(`/employees?q=${teamId}&_ehphide=${true}`);
    };

    return (
      <>
        {!isDefaultSet && teams.length > 0 && (
          <WarningAlert
            icon={<i className="bi bi-exclamation-triangle-fill me-2"></i>}
            message="Warning: No default team is set. Please set it to prevent rendering wrong data."
          />
        )}
        <Table striped responsive bordered className="text-center">
          <thead>
            <tr>
              {(isAllowedToUpdate || isAllowedToDelete) && <th></th>}
              <th>S No.</th>
              <th>Team</th>
              <th>Team Leader</th>
              {(isAllowedToUpdate ||
                isAllowedToDelete ||
                isAllowedToReadEmployees) && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {teams.length > 0 ? (
              teams.map((row, index) => (
                <tr key={row.id} id={row?.isDefault ? "default" : ""}>
                  {(isAllowedToUpdate || isAllowedToDelete) && (
                    <td>
                      <Form.Check
                        type="checkbox"
                        name="row"
                        value={row.id}
                        checked={selectedRow?.id === row.id}
                        onChange={(e) => handleCheckboxChange(e, row)}
                      />
                    </td>
                  )}
                  <td>{index + 1}</td>
                  <td>{row.name}</td>
                  <td>{row?.teamLeadId ? <NavLink to={`/employee/${row.teamLeadId.employeeId}`}>{row.teamLeadId.name}</NavLink> : "—"}</td>
                  {(isAllowedToUpdate ||
                    isAllowedToDelete ||
                    isAllowedToReadEmployees) && (
                    <td>
                      {isAllowedToReadEmployees && (
                        <Button
                          size="sm"
                          variant="outline-success"
                          className="me-2"
                          onClick={() => viewTeamEmployees(row.id)}
                        >
                          <i className="bi bi-eye"></i>
                        </Button>
                      )}
                      {isAllowedToUpdate && (
                        <Button
                          size="sm"
                          variant="outline-primary"
                          className="me-2"
                          disabled={!selectedRow || selectedRow?.id !== row.id}
                          onClick={() => onEdit(row)}
                        >
                          <i className="bi bi-pencil-square"></i>
                        </Button>
                      )}

                      {isAllowedToDelete && (
                        <Button
                          size="sm"
                          variant="outline-danger"
                          disabled={!selectedRow || selectedRow?.id !== row.id}
                          onClick={deleteTeamManage}
                        >
                          <i className="bi bi-trash3"></i>
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr className="bg-light border text-center">
                <td colSpan={6} className="text-muted">
                  {isLoading ? "Loading Data..." : "No Data Found"}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    );
  }
);

export default TeamViewManagement;
